import React, { Component } from "react";
import Header from "../header";

class Rules extends Component {
  render() {
    return (
      <div className="showMore-rules">
        <Header showSearchBar={true} title={"قوانین و ضوابط | کاچار"} />
        <iframe
          src="https://kacharlife.com/rules"
          seamless
          style={{ border: "none", height: "90vh", width: "100vw" }}
          allow="fullscreen"
          title="rules"
        />
      </div>
    );
  }
}
export default Rules;
